import React from 'react';
import Findbg from '../../../assets/images/findsec.jpg';
import Shape16 from '../../../assets/images/shape-16.png';
import { config } from '../config';

const FindSection = () => {
  const statsList = [
    '15+ Years of Experience',
    'Thousands of Lessons Delivered',
    'Automatic & Manual Tuition',
    'Flexible Lesson Times',
    'Friendly Local Driving Instructors',
  ];

  return (
    <div>
      <section className="find-section">
        <div
          className="bg-layer"
          style={{ backgroundImage: `url(${Findbg})` }}
        ></div>
        <div className="upper-box">
          <div className="bg-color"></div>
          <div className="shape">
            <div
              className="shape-1"
              style={{ backgroundImage: `url(${Shape16})` }}
            ></div>
          </div>
          <div className="auto-container">
            <div className="row clearfix">
              <div className="col-lg-6 col-md-12 col-sm-12 content-column">
                <div
                  className="content-box position-relative"
                  style={{ zIndex: 10 }}
                >
                  <div className="sec-title">
                    <h2>
                      Helping Learners Drive{' '}
                      <br className="d-none d-md-block" />
                      with Confidence Across Leicester
                    </h2>
                  </div>
                  <div className="row my-3 g-2">
                    {statsList.map((item, index) => (
                      <div
                        key={index}
                        className="col-md-6 col-12 d-flex align-items-center mb-3"
                      >
                        <i className="bi bi-check-circle-fill text-green me-2 fs-5 flex-shrink-0"></i>
                        <span
                          style={{
                            color: '#121113',
                            fontSize: '15px',
                            fontWeight: '600',
                            lineHeight: '1.3',
                          }}
                        >
                          {item}
                        </span>
                      </div>
                    ))}
                  </div>
                  <div className="form-group mt-3">
                    <a href={`${config.appUrl}contact-us`}>
                      <button type="submit" className="theme-btn btn-two">
                        Send Request
                      </button>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FindSection;
